export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";